import React from "react";
import PostCardTable from "./PostCardTable";
import AdminLayout from "./component/AdminLayout";


const AuthorPostCard = () => {

    return (
        <AdminLayout
            pageTitle="엽서 관리"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'Postcard', active: true }
            ]}
        >

            <div className="main-content">
                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white py-3">
                        <h6 className="mb-0 fw-bold">전체 엽서 목록</h6>
                    </div>
                    <div className="card-body p-0">
                        <PostCardTable />
                    </div>
                </div>
            </div>
        </AdminLayout>
    )

}

export default AuthorPostCard;
